export interface IValidation {
    firstName: boolean,
    lastName: boolean,
    birthDate: boolean,
    donationType: boolean,
    transplantDate: boolean
}